import { QueryClient } from "@tanstack/query-core";
import { Route } from "react-router-dom";
import { SetErrorMessageType } from "@/app/providers/ReactContextProvider/types";
import { cabinetLoader } from "@/router/loaders/cabinetLoader";
import { RouterPath } from "@/router/types";
import { PageSpinner } from "@/shared/ui/PageSpinner";
import { LayoutBaseFooter } from "@/widgets/Layout/BaseFooter";

export const signupRouter = (
  queryClient: QueryClient,
  setErrorMessage: SetErrorMessageType,
) => (
  <Route element={<LayoutBaseFooter />}>
    <Route
      path={RouterPath.LeadBiometry}
      loader={cabinetLoader(queryClient, setErrorMessage)}
      lazy={() => import(/* webpackPrefetch: true */ "@/pages/LeadBiometry")}
      HydrateFallback={PageSpinner}
    />
    <Route
      path={RouterPath.ProfileRefill}
      loader={cabinetLoader(queryClient, setErrorMessage)}
      lazy={() => import(/* webpackPrefetch: true */ "pages/ProfileCompletion")}
      HydrateFallback={PageSpinner}
    />
    <Route
      path={RouterPath.LeadApply}
      loader={cabinetLoader(queryClient, setErrorMessage)}
      lazy={() => import(/* webpackPrefetch: true */ "@/pages/LeadApply")}
      HydrateFallback={PageSpinner}
    />
    <Route
      path={RouterPath.LeadSign}
      loader={cabinetLoader(queryClient, setErrorMessage)}
      lazy={() => import(/* webpackPrefetch: true */ "@/pages/LeadSign")}
      HydrateFallback={PageSpinner}
    />
    <Route
      path={RouterPath.LoanSubmit}
      loader={cabinetLoader(queryClient, setErrorMessage)}
      lazy={() => import(/* webpackPrefetch: true */ "@/pages/LoanSubmit")}
      HydrateFallback={PageSpinner}
    />
    <Route
      path={RouterPath.LoanBiometry}
      loader={cabinetLoader(queryClient, setErrorMessage)}
      lazy={() => import(/* webpackPrefetch: true */ "@/pages/LoanBiometry")}
      HydrateFallback={PageSpinner}
    />
  </Route>
);
